<mat-card>
  <div class="d-flex justify-content-between gap-2 mt-1">
    <!--      <div class="text-left">-->
    <!--        <button mat-raised-button color="warn" (click)="closeView()" type="button">-->
    <!--          <mat-icon>keyboard_backspace</mat-icon>&nbsp;&nbsp;Back-->
    <!--        </button>-->
    <!--      </div>-->
    <!--      <div class="text-right">-->
    <!--        <button mat-raised-button color="primary" (click)="print()" type="button">-->
    <!--          <mat-icon>print</mat-icon>&nbsp;&nbsp;Print-->
    <!--        </button>-->
    <!--      </div>-->
  </div>

  <div id="printableArea">
    <h2 class="text-center mt-2">Hospital Details</h2>

    <table style="width: 100%; border: 1px solid #ddd; border-collapse: collapse;">
      <tr>
        <th style="width: 25%; border: 1px solid #ddd; padding: 8px;">Hospital Name</th>
        <td style="width: 75%; border: 1px solid #ddd; padding: 8px;">{{ data.hospitalName }}</td>
      </tr>
      <tr>
        <th style="border: 1px solid #ddd; padding: 8px;">Short Name</th>
        <td style="border: 1px solid #ddd; padding: 8px;">{{ data.shortName }}</td>
      </tr>
      <tr>
        <th style="border: 1px solid #ddd; padding: 8px;">Website Link</th>
        <td style="border: 1px solid #ddd; padding: 8px;">{{ data.websiteLink }}</td>
      </tr>

      <!-- Doctor Details -->
      <tr *ngIf="data.drDetails && Array.isArray(data.drDetails) && data.drDetails.length > 0; else singleDoctor">
        <th style="border: 1px solid #ddd; padding: 8px;">Doctor Name</th>
        <td style="border: 1px solid #ddd; padding: 8px;">
          <ng-container *ngFor="let doctor of data.drDetails; let i = index">
            {{ doctor.doctorsName }} - {{ doctor?.phoneNo }}{{ i < data.drDetails.length - 1 ? ', ' : '' }}
          </ng-container>
        </td>
      </tr>

      <!-- Social Worker Details -->
      <tr
        *ngIf="data.socialWorkerDetails && Array.isArray(data.socialWorkerDetails) && data.socialWorkerDetails.length > 0; else singleSocialWorker">
        <th style="border: 1px solid #ddd; padding: 8px;">Social Worker Name</th>
        <td style="border: 1px solid #ddd; padding: 8px;">
          <ng-container *ngFor="let worker of data.socialWorkerDetails; let i = index">
            {{ worker.socialWorkerName }}
            - {{ worker?.phoneNo }}{{ i < data.socialWorkerDetails.length - 1 ? ', ' : '' }}
          </ng-container>
        </td>
      </tr>

      <!-- Administration Details -->
      <tr
        *ngIf="data.adminDetails && Array.isArray(data.adminDetails) && data.adminDetails.length > 0">
        <th style="border: 1px solid #ddd; padding: 8px;">Administration</th>
        <td style="border: 1px solid #ddd; padding: 8px;">
          <ng-container *ngFor="let admin of data.adminDetails; let i = index">
            {{ admin.name }}
            - {{ admin?.phoneNo }}{{ i < data.adminDetails.length - 1 ? ', ' : '' }}
          </ng-container>
        </td>
      </tr>

      <!-- Fallbacks -->
      <ng-template #singleDoctor>
        <tr *ngIf="data.doctorsName">
          <th style="border: 1px solid #ddd; padding: 8px;">Doctor Name</th>
          <td style="border: 1px solid #ddd; padding: 8px;">{{ data.doctorsName }}</td>
        </tr>
      </ng-template>

      <ng-template #singleSocialWorker>
        <tr *ngIf="data.socialWorkerName">
          <th style="border: 1px solid #ddd; padding: 8px;">Social Worker Name</th>
          <td style="border: 1px solid #ddd; padding: 8px;">{{ data.socialWorkerName }} - {{ data?.phoneNo }}</td>
        </tr>
      </ng-template>

      <tr>
        <th style="border: 1px solid #ddd; padding: 8px;">Address</th>
        <td style="border: 1px solid #ddd; padding: 8px;">{{ data.address }}</td>
      </tr>
      <tr>
        <th style="border: 1px solid #ddd; padding: 8px;">City</th>
        <td style="border: 1px solid #ddd; padding: 8px;">{{ data.city }}</td>
      </tr>
      <tr>
        <th style="border: 1px solid #ddd; padding: 8px;">State</th>
        <td style="border: 1px solid #ddd; padding: 8px;">{{ data.state }}</td>
      </tr>
      <tr>
        <th style="border: 1px solid #ddd; padding: 8px;">Pin Code</th>
        <td style="border: 1px solid #ddd; padding: 8px;">{{ data.zipcode }}</td>
      </tr>
    </table>
    <h3>Doctor Details</h3>
    <table style="width: 100%; border: 1px solid #ddd; border-collapse: collapse;">
      <tr *ngIf="data.drDetails?.length">
        <th style="border: 1px solid #ddd; padding: 8px;">Doctor's Name</th>
        <th style="border: 1px solid #ddd; padding: 8px;">Designation</th>
        <th style="border: 1px solid #ddd; padding: 8px;">Contact</th>
        <th style="border: 1px solid #ddd; padding: 8px;">Email</th>
      </tr>
      <tr *ngFor="let doc of data.drDetails">
        <td style="border: 1px solid #ddd; padding: 8px;">{{ doc.doctorsName }}</td>
        <td style="border: 1px solid #ddd; padding: 8px;">{{ doc.designation }}</td>
        <td style="border: 1px solid #ddd; padding: 8px;">{{ doc.phoneNo }}</td>
        <td style="border: 1px solid #ddd; padding: 8px;">{{ doc.email }}</td>
      </tr>
    </table>
    <h3>MSW Details</h3>
    <table style="width: 100%; border: 1px solid #ddd; border-collapse: collapse;">
      <tr *ngIf="data.socialWorkerDetails?.length">
        <th style="border: 1px solid #ddd; padding: 8px;">Social Worker Name</th>
        <th style="border: 1px solid #ddd; padding: 8px;">Contact</th>
        <th style="border: 1px solid #ddd; padding: 8px;">Email</th>
      </tr>
      <tr *ngFor="let sw of data.socialWorkerDetails">
        <td style="border: 1px solid #ddd; padding: 8px;">{{ sw.socialWorkerName }}</td>
        <td style="border: 1px solid #ddd; padding: 8px;">{{ sw.phoneNo }}</td>
        <td style="border: 1px solid #ddd; padding: 8px;">{{ sw.email }}</td>
      </tr>
    </table>
    <h3>Administration Details</h3>
    <table style="width: 100%; border: 1px solid #ddd; border-collapse: collapse;">
      <tr *ngIf="data.adminDetails?.length">
        <th style="border: 1px solid #ddd; padding: 8px;">Name</th>
        <th style="border: 1px solid #ddd; padding: 8px;">Designation</th>
        <th style="border: 1px solid #ddd; padding: 8px;">Contact</th>
        <th style="border: 1px solid #ddd; padding: 8px;">Email</th>
      </tr>
      <tr *ngFor="let admin of data.adminDetails">
        <td style="border: 1px solid #ddd; padding: 8px;">{{ admin.name }}</td>
        <td style="border: 1px solid #ddd; padding: 8px;">
          {{ admin.designation === 'Other' ? admin.customDesignation : admin.designation }}
        </td>
        <td style="border: 1px solid #ddd; padding: 8px;">{{ admin.phoneNo }}</td>
        <td style="border: 1px solid #ddd; padding: 8px;">{{ admin.email }}</td>
      </tr>
    </table>
    <h3>Removed Doctor Details</h3>
    <table style="width: 100%; border: 1px solid #ddd; border-collapse: collapse;">
      <tr *ngIf="removedDrDetails?.length">
        <th style="border: 1px solid #ddd; padding: 8px;">Doctor's Name</th>
        <th style="border: 1px solid #ddd; padding: 8px;">Designation</th>
        <th style="border: 1px solid #ddd; padding: 8px;">Contact</th>
        <th style="border: 1px solid #ddd; padding: 8px;">Email</th>
        <th style="border: 1px solid #ddd; padding: 8px;">Reason</th>
      </tr>
      <tr *ngFor="let doc of removedDrDetails">
        <td style="border: 1px solid #ddd; padding: 8px;">{{ doc.doctorsName }}</td>
        <td style="border: 1px solid #ddd; padding: 8px;">{{ doc.designation }}</td>
        <td style="border: 1px solid #ddd; padding: 8px;">{{ doc.phoneNo }}</td>
        <td style="border: 1px solid #ddd; padding: 8px;">{{ doc.email }}</td>
        <td style="border: 1px solid #ddd; padding: 8px;">{{ doc.reason }}</td>
      </tr>
    </table>
    <h3>Assigned Center(s)</h3>
    <table style="width: 100%; border: 1px solid #ddd; border-collapse: collapse;">
      <tr *ngIf="assignedCenters?.length">
        <th style="border: 1px solid #ddd; padding: 8px;">#</th>
        <th style="border: 1px solid #ddd; padding: 8px;">Center Code</th>
      </tr>
      <tr *ngFor="let center of assignedCenters; let i = index">
        <td style="border: 1px solid #ddd; padding: 8px;">{{ i + 1 }}</td>
        <td style="border: 1px solid #ddd; padding: 8px;">{{ center.centreCode }}</td>
      </tr>
      <tr *ngIf="!assignedCenters?.length">
        <td colspan="2" style="border: 1px solid #ddd; padding: 8px; text-align:center;">
          No centers assigned
        </td>
      </tr>
    </table>
    <h3>Notes</h3>
    <table style="width: 100%; border: 1px solid #ddd; border-collapse: collapse;">
      <tr *ngIf="notesArray?.length">
        <th style="border: 1px solid #ddd; padding: 8px;">#</th>
        <th style="border: 1px solid #ddd; padding: 8px;">Remark</th>
      </tr>
      <tr *ngFor="let note of notesArray; let i = index">
        <td style="border: 1px solid #ddd; padding: 8px;">{{ i + 1 }}</td>
        <td style="border: 1px solid #ddd; padding: 8px;">{{ note.remark }}</td>
      </tr>
    </table>
  </div>
</mat-card>

<!--upload section-->
<div class="d-flex justify-content-end">
  <button *ngIf="!showUpload" mat-raised-button color="accent" (click)="showUpload= !showUpload">Add Hospital
    Documents
  </button>
  <button *ngIf="showUpload" mat-raised-button color="accent" (click)="showUpload= !showUpload">Hide Hospital
    Documents
  </button>
</div>
<section *ngIf="showUpload">
  <h3>Image Upload</h3>
  <div>
    {{ selectedTitle }}
    <mat-form-field appearance="outline" class="mr-4">
      <mat-label>Document Title</mat-label>
      <mat-select [(ngModel)]="selectedTitle">
        <mat-option *ngFor="let title of mHospitalDocumentsType$|async" [value]="title">
          {{ title }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <button *ngIf="userData?.role?.includes('Admin') || userData?.role?.includes('admin')" 
            mat-icon-button color="primary" class="mr-2" 
            (click)="addNewDocumentType()" matTooltip="Add new Document Type">
      <mat-icon>add</mat-icon>
    </button>
    <button mat-raised-button color="primary" (click)="openDialog()" [disabled]="!selectedTitle">
      Add Dates
    </button>
  </div>
  <input type="file" (change)="onFileSelected($event)"/>

  <button mat-raised-button color="accent" (click)="uploadFile()">Upload</button>

  <div *ngIf="uploadProgress$ | async as progress">
    Uploading: {{ progress | number: '1.0-0' }}%
  </div>

  <!--  <app-image-upload [addToArray]="true" [uploadWithTitle]="true" dbType="realtime" [pathToDatabase]='mHospitalPath'-->
  <!--                    storagePath="hospitalDocuments" [title]="selectedTitle"></app-image-upload>-->
</section>


<div class="cdk-virtual-scroll-data-source-example">
  <cdk-virtual-scroll-viewport orientation="horizontal" itemSize="250" class="example-viewport">
    <div *cdkVirtualFor="let d of (mHopitalDoucmentsObservable$ | async); let i = index" class="example-item">
      <span>
      <a [href]="d.imageUrl + '?alt=media'" target="_blank">
  <img
    [src]="d.imageUrl + '?alt=media'"
    [alt]="d.fileName || 'Image'"
    onerror="this.src='assets/images/no-image.png'"
    style="width: 250px; height: 250px; cursor: pointer;"
    class="img-thumbnail img-fluid"
  />
</a>


        <div class="d-flex justify-content-between">
          <strong class="text-center">{{ d.fileName }}</strong>
          <mat-icon color="warn" (click)="deleteDocument(d)">delete</mat-icon>
        </div>

        <!-- Correct date display -->
        <div class="mt-2 small text-muted">
          <div *ngIf="d.renewalDate">Renewal: {{ d.renewalDate | date: 'mediumDate' }}</div>
          <div *ngIf="d.dueDate">Due: {{ d.dueDate | date: 'mediumDate' }}</div>
        </div>
      </span>
    </div>
  </cdk-virtual-scroll-viewport>
</div>

<!-- Dr Removed Section -->



